'use strict';

const $ = jQuery.noConflict();

$(function() {
	const brandCards = {
		currentIndex: 0,
		totalCards: 0,
		isAnimating: false,
		animationDuration: 1100,

		init: function() {
			this.cacheDOM();

			if (!this.$section.length || !this.$cards.length) {
				return;
			}

			this.totalCards = this.$cards.length;

			// Only animate on desktop without reduced-motion preference
			const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
			const isDesktop = window.innerWidth > 991;

			if (prefersReduced || !isDesktop || this.totalCards < 2) {
				// Ensure all cards are visible when not animating
				this.$cards.removeAttr('aria-hidden');
				return;
			}

			this.$section.addClass('brand-cards--animated');
			this.$track.css('--brand-cards-height', this.totalCards * 100 + 'vh');

			// On refresh the page may already be scrolled — snap to correct card instantly
			this.syncOnLoad();
			this.bindEvents();
		},

		cacheDOM: function() {
			this.$section = $('.js-brand-cards');
			this.$track = $('.js-brand-cards-track');
			this.$sticky = $('.js-brand-cards-sticky');
			this.$cards = $('.js-brand-cards-card');
			this.$announcement = $('.js-brand-cards-announcement');
		},

		syncOnLoad: function() {
			const trackRect = this.$track[0].getBoundingClientRect();
			const trackHeight = this.$track[0].offsetHeight;
			const viewportH = window.innerHeight;
			const scrolled = -trackRect.top;
			const scrollable = trackHeight - viewportH;

			let startIndex = 0;

			if (scrolled > 0 && scrollable > 0) {
				const progress = Math.min(scrolled / scrollable, 1);
				startIndex = Math.min(
					Math.floor(progress * this.totalCards),
					this.totalCards - 1
				);
			}

			// Activate the correct card without animation
			this.$cards.removeClass('is-active is-leaving').attr('aria-hidden', 'true');
			this.$cards.eq(startIndex).addClass('is-active').removeAttr('aria-hidden');

			this.currentIndex = startIndex;
			this.announceCard(startIndex);
		},

		bindEvents: function() {
			$(window).on('scroll.brandCards', this.handleScroll.bind(this));
			$(window).on('resize.brandCards', this.handleResize.bind(this));

			// Keyboard navigation: arrow keys move between brands
			this.$section.on('keydown', this.handleKeydown.bind(this));
		},

		handleScroll: function() {
			if (!this.$track.length) {
				return;
			}

			const trackRect = this.$track[0].getBoundingClientRect();
			const trackHeight = this.$track[0].offsetHeight;
			const viewportH = window.innerHeight;
			const scrolled = -trackRect.top;
			const scrollable = trackHeight - viewportH;

			// Outside the section's scroll range
			if (scrolled <= 0 || scrolled >= scrollable) {
				const clampedIndex = scrolled <= 0 ? 0 : this.totalCards - 1;
				if (clampedIndex !== this.currentIndex) {
					this.goTo(clampedIndex);
				}
				return;
			}

			const progress = scrolled / scrollable;
			const newIndex = Math.min(
				Math.floor(progress * this.totalCards),
				this.totalCards - 1
			);

			if (newIndex !== this.currentIndex) {
				this.goTo(newIndex);
			}
		},

		handleResize: function() {
			// Disable animation below tablet breakpoint
			if (window.innerWidth <= 991) {
				this.$section.removeClass('brand-cards--animated');
				this.$cards.removeAttr('aria-hidden').css({opacity: '', transform: '', 'pointer-events': ''});
				this.$cards.removeClass('is-active is-leaving');
				$(window).off('scroll.brandCards resize.brandCards');
				this.$dots.off('click');
				this.$section.off('keydown');
			}
		},

		goTo: function(index) {
			if (this.isAnimating || index === this.currentIndex) {
				return;
			}

			this.isAnimating = true;

			const $outgoing = this.$cards.eq(this.currentIndex);
			const $incoming = this.$cards.eq(index);

			$outgoing.addClass('is-leaving').removeClass('is-active');
			$incoming.addClass('is-active').removeAttr('aria-hidden');

			setTimeout(() => {
				$outgoing.removeClass('is-leaving').attr('aria-hidden', 'true');
				this.isAnimating = false;
			}, this.animationDuration);

			this.currentIndex = index;
			this.announceCard(index);
		},

		scrollToCard: function(index) {
			const trackTop = this.$track[0].offsetTop;
			const trackHeight = this.$track[0].offsetHeight;
			const viewportH = window.innerHeight;
			const scrollable = trackHeight - viewportH;
			const fraction = this.totalCards > 1
				? index / (this.totalCards - 1)
				: 0;
			const targetScroll = trackTop + fraction * scrollable;

			window.scrollTo({top: targetScroll, behavior: 'smooth'});
		},

		handleKeydown: function(e) {
			// Only intercept when focus is within this section
			const isFocusInSection = this.$section[0].contains(document.activeElement);
			if (!isFocusInSection) {
				return;
			}

			const isNext = e.key === 'ArrowDown' || e.key === 'ArrowRight';
			const isPrev = e.key === 'ArrowUp' || e.key === 'ArrowLeft';

			if (!isNext && !isPrev) {
				return;
			}

			e.preventDefault();

			if (isNext && this.currentIndex < this.totalCards - 1) {
				this.scrollToCard(this.currentIndex + 1);
			} else if (isPrev && this.currentIndex > 0) {
				this.scrollToCard(this.currentIndex - 1);
			}
		},

		// Politely announce brand change to screen readers
		announceCard: function(index) {
			const $card = this.$cards.eq(index);
			const label = $card.data('brand-name') || $card.attr('aria-label') || '';
			const message = label
				? label + ', ' + (index + 1) + ' of ' + this.totalCards
				: '';

			// Clear first so repeated same-card triggers still fire
			this.$announcement.text('');
			setTimeout(() => {
				this.$announcement.text(message);
			}, 50);
		},
	};

	brandCards.init();
});
